import * as Yup from 'yup';

// Email regex pattern for consistency with existing validation
const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

// Password validation pattern for Cognito requirements
const passwordValidation = Yup.string()
  .required('Password is required')
  .min(8, 'Password must be at least 8 characters long')
  .matches(/(?=.*[a-z])/, 'Password must include at least one lowercase letter')
  .matches(/(?=.*[A-Z])/, 'Password must include at least one uppercase letter')
  .matches(/(?=.*\d)/, 'Password must include at least one number')
  .matches(/(?=.*[!@#$%^&*(),.?":{}|<>])/, 'Password must include at least one special character');

// Login validation schema
export const loginSchema = Yup.object({
  username: Yup.string()
    .required('Email is required')
    .matches(emailRegex, 'Please enter a valid email address'),
  password: Yup.string().required('Password is required'),
});

// Signup validation schema
export const signupSchema = Yup.object({
  signupCode: Yup.string()
    .required('Signup code is required')
    .trim(),
  email: Yup.string()
    .required('Email is required')
    .matches(emailRegex, 'Please enter a valid email address'),
  password: passwordValidation,
  confirmPassword: Yup.string()
    .required('Please confirm your password')
    .oneOf([Yup.ref('password')], 'Passwords do not match'),
  termsAccepted: Yup.boolean()
    .required('You must accept the terms and conditions')
    .oneOf([true], 'You must accept the terms and conditions'),
});

// Forgot password validation schema
export const forgotPasswordSchema = Yup.object({
  email: Yup.string()
    .required('Email is required')
    .matches(emailRegex, 'Please enter a valid email address'),
});

// Reset password validation schema
export const resetPasswordSchema = Yup.object({
  code: Yup.string()
    .required('Verification code is required')
    .trim(),
  password: passwordValidation,
  confirmPassword: Yup.string()
    .required('Please confirm your password')
    .oneOf([Yup.ref('password')], 'Passwords do not match'),
});

// Type definitions for form data
export interface LoginFormData {
  username: string;
  password: string;
}

export interface SignupFormData {
  signupCode: string;
  email: string;
  password: string;
  confirmPassword: string;
  termsAccepted: boolean;
}

export interface ForgotPasswordFormData {
  email: string;
}

export interface ResetPasswordFormData {
  code: string;
  password: string;
  confirmPassword: string;
}